var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Report',{ref:"report",attrs:{"data":_vm.task_data,"info":_vm.task_info,"record":_vm.task_record}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }